import { RandomNumberGenerationSource } from 'd3';
import { CustomFieldsConfiguration } from '../.././shared/custom-fields/custom-fields-models';

export class AdvancedSearch {
    ZoneId: number;
    Zone: string;
    TimeZoneId: number;
    TimeZoneCode: string;
    WorkTypeId: number;
    WorkType: string;
    WorkTask: string;
    WorkTaskId: number;
    JobStatusId: number;
    JobStatus: string;
    CompanyId: number;
    CompanyName: string;
    HoursPerTask: number;
    MinutesPerTask: number;
    FirstName: string;
    LastName: string;
    LoginId: number;
    VendorId: number;
    technicianName: Technician[];
}

export class JobStatus {
    JobStatusId: number;
    JobStatus: string;
}

export class VendorName {
    VendorId: number;
    VendorName: string;
}

export class Technician {
    Email: string;
    LoginId: number;
    FirstName: string;
    LastName: string;
    DisplayName: string;
    Phone1: number;
    Phone2: number;
    Designation: string;
    ManagerId: number;
    UniquRefNo: string;
    Roles: string;
    Manager: string;
    Zones: string;
    Regions: string;
    IsActive: number;
    VendorId: number;
}

export class TechnicianDetails {
    LoginId: number;
    DisplayName: string;
    VendorId: number;
}

export class Region {
    Region: string;
    RegionId: number;
}

export class TechnicianName {
    LoginId: number;
    FirstName: string;
    LastName: string;
    VendorId: number;
    DisplayName: string;
}

export class AdvancedSearchModel {
    CompanyId: number;

    ZoneId: number;
    RegionId: number;
    // CustomerId: number;
    CustomerName: string;
    WoNumber: string;

    WoJobId: number;
    TimeZoneId: number;
    WorkTypeId: number;
    JobStatusId: number;
    VendorId: number;
    TechId: string;
    WoCategoryId: number;
    ScheduleStDate: string;
    ScheduleEdDate: string;
    IsPmOrder: number;
    IsPm: boolean;
    IsActive: number;
    SortBy: string;
    OrderBy: string;
    startRecord: number;
    EndRecord: number;
    LoginId: number;
    WorkOrderId: number;
    Phone1: string;
    LoginVendorId?: number;
    MaxRoleGroupId?: number;
    ProjectId?: number;
    RequestedBy: string;
    SearchText: string;
    FromDate: string;
    ToDate: string;
    ClliCode: string;
    WoCategory: string
}

export class Pagination {
    CompanyId: number;
    IsActive: number;
    SortBy: string;
    OrderBy: string;
    startRecord: number;
    EndRecord: number;
}

export class JobDetailList {
    TechJobDetails: JobDetailMaster[];
    TotalRecord: number;
}

export class JobDetailMaster {
    WorkOrderId: number;
    WoNumber: string;
    WoJobId: number;
    JobNo: string;
    SchedulStartDateTime: string;
    ScheduleStartDateTime: string;
    ScheduleStartDateTimeTag: string;
    ScheduleEndDateTime: Date;
    JobStatusid: number;
    JobStatus: string;
    CustomerTypeId: number;
    CustomerType: string;
    CustomerId: number;
    CustomerName: string;
    AddressName: string;
    AddressTypeid: number;
    AddressLine1: string;
    AddressLine2: string;
    UnitNo: string;
    CityName: string;
    ZipCode: string;
    Phone1: string;
    Phone2: string;
    WoCategoryId: number;
    WoCategory: string;
    WorkRequestCount: number;
    Days: number;
    Hours: number;
    Minutes: number;
    IsPmOrder: number;
    TechDisplayName: string;
    Zone: string;
    Region: string;
    JobDescription: string;
    ApptPrefDate: Date;
    ApptPrefTime: Date;
    ApptPrefDateFormat: string;
    ApptPrefTimeFormat: string;
    FirstName: string;
    LastName: string;
    WoStatus: string;
    TechId: number;
    UserLat: number;
    UserLon: number;
    ZipLat: number;
    ZipLon: number;
    MapLat: number;
    MapLon: number;
    CreatedBy: number;
    SLAStartTime: string;
    SLAEndTime: string;
    SLAEndTimeUtc: string;
    WoJobDetailsId: number;
    ServiceAddressId: number;
    DayHourMinutes: any;
    CreatedDate: string;
    TechTimeZoneId: number;
    CustAddressId: number;
    CusTimeZoneId: number;
    CustomPanel: string;
    PanelName: string;
    VendorId: number;
    SlotStartTime: string;
    SlotEndTime: string;
    AcctualAddress: string;
    ColorCode?:string;
    SlotStartTimeval: string;
    SlotEndTimeval: string;
    RequestedBy: string;
    EnableInhouseJobVendorApproval?:number;
    IsSLAMet: number;
    Duration: number;
    VendorName: string;
    ActualContactName: string;
    PriorityName: string;
    SlotName: string;
    CreatedDateCtz: string;
    ClliCode: string;
    IsNetwork?: number;
    InProgressTime?: string;
    VendorApprovalStatusId?: number;
    vendordapprovedate: string;
    IsCompanyUserRejected?:number;
    ApprovalStatusId?:number;
    EnableFieldJobVendorApproval?:number;

}

export class Status {
    constructor(public id: number,
        public name: string) { }
}

export class Sample {
    CompanyId: number;

    ZoneId: number;
    RegionId: number;
    // CustomerId: number;
    CustomerName: string;
    WoNumber: string;

    WoJobId: number;
    TimeZoneId: number;
    WorkTypeId: number;
    JobStatusId: number;
    VendorId: number;
    TechId: string;

    ScheduleStDate: Date;
    ScheduleEdDate: Date;
    IsPmOrder: number;
    IsPm: boolean;
    IsActive: number;
    SortBy: string;
    OrderBy: string;
    startRecord: number;
    EndRecord: number;
}


export class CustomerAndJobdetails {
    CustomerDetails: CustomerDetail;
    JobDetails: JobDetail;
}

export class CustomerDetail {
    JobId: number;
    AddressLine1: string;
    FirstName: string;
    MiddleInitial: string;
    LastName: string;
    Phone1: string;
    Phone2: string;
    CustomerType: string;
    Region: string;
    RequestedBy: string;
    CustAddressId: number;
    CustomerName: string;
    CustomerId: number;
    Zone: string;
    ClliCode: string;
    IsNetwork?: number;
}

export class JobDetail {
    TechId?: number;
    ScheduleStartDateTime: string;
    ScheduleEndDateTime: string;
    ApptPrefDate: Date;
    ApptPrefTime: Date;
    Days: number;
    Hours: number;
    Minutes: number;
    JobStatus: string;
    SLAStartTime: string;
    SLAEndTime: string;
    SLAEndTimeUtc: string;
    DayTime: any;
    SLAFormat: any;
    JobStatusId: number;
    IsSLAMet: number;
    IsSLAMetString: string;
    Duration: number;
    DurationString: string;
    VendorName: string;
    ScheduleSlot: string;
    PriorityName: string;

}

export class RefStatusReasonEntity {
    WoAppointmentStatusReasonId: number;
    StatusReasonId: number;
    StatusReason: string;
}

//Customer Edit Service Contact

export class EditServiceContact {
    WorkOrderId: number;
    WoJobId: number;
    WoContactId: number;
    CustomerTypeId: number;
    CustomerType: string;
    CustomerId: number;
    TitleId: number;
    FirstName: string;
    MiddleInitial: string;
    LastName: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    Email: string;
    Titles: number;
    CompanyId: number;
    AddressTypeId: number;
    ContactTypeId: number;
    IsPrimary: number;
    LastChangedBy: number;
    CustContactId: number;
    WoAddressId: number;
    CreatedBy: number;
    customerContactflag: number;
    ISActive: number;
}

export class Titles {
    ConfigDtlId: number;
    ConfigMasterId: number;
    Description: string;
}

export class ContactType {
    ConfigDtlId: number;
    Description: string;
}

export class WorkOrderCustomerContactDetail {
    WorkOrderCustomerContactDetails: EditServiceContact;
    Titles: Titles[];
    ContactType: ContactType[];
}

export class AttachmetDt {
    componentName: string;
    isAttchmentUploaded: boolean;
    uploadedFile: any[];
    woJobid: number;
}

export class FileDetails {
    workorderId: number;
    companyId: number;
    woJobid: number;
    FileName: string;
}

// Map
export class marker {
    lat: number;
    lng: number;
    label?: string;
    draggable: boolean;
}

export class MapView {
    UserLat: number;
    UserLon: number;
    ZipLat: number;
    ZipLon: number;
    MapLat: number;
    MapLon: number;

    AddresLine1: string;
    AddresLine2: string;
    Cityame: string;
    ZipCode: string;
}


export class JobCompStatus {
    JobStatusCompId: number;
    JobStatusId: number;
    JobStatus: string;
    StatusReason: string;
    Description: string;
    IsActive: number;
    StatusReasonId: number;
}

export class JobAppointMent {
    WoAppointmentId: number;
    CompanyId: number;
    WorkOrderId: number;
    WoJobId: number;
    TechId: number;
    AppointmentStatusId: number;
    StatusReasonId: number;
    StatusReason: string;
    ScheduleStartDate: Date;
    ScheduleEndDate: Date;
    TravelTime: number;
    TravelDistance: any;
    StartTime: Date;
    ArrivalTime: string;
    ServiceStartTime: string;
    ServiceEndTime: string;
    DepartureTime: string;
    TechNotes: string;
    CustomerFeedback: string;
    IsActive: boolean;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    ScheduleStartDateTtz: Date;
    ScheduleEndDateTtz: Date;
    ScheduleStartDateCtz: Date;
    ScheduleEndDateCtz: Date;
    ReturnTravelTime: number;
    ReturnTravelDistance: any;
    CustomerSignature: any;
    IsCustomerSignatureReq: any;

    StartTime1: string;
    ArrivalTime1: string;
    ServiceEndTime1: string;
    SubmittedSource: number;
    SubmittedDate: string;
    SubmittedByUserId: number;
    ActualWorkedDays: number;
    ActualWorkedHours: number;
    ActualWorkedMinutes: number;
    ActualTravelDistance?: any;
    Reasons: RefStatusReasonEntity[];

}

export class ManageTechnicianJobs {
    TechJobDetails: JobDetailMaster[];
    WoJobCompStatus: JobCompStatus[];
    WorkOrderJobAppointment: JobAppointMent;
    systemSetting: SystemSetting;
    WorkDoneTimingsEntity: worldonetiming[];
    VendorApprovalStatus?: VendorApprovalStatus[];
    companyvendor?:companyvendor;
}
export class VendorApprovalStatus
{
    ApprovalStatusCompId?:number;
    ApprovalStatusId?:number;
    ApprovalStatus:string;   
    ColorCode:string;
    Description:string;
    IsActive?:number;
}


export class SystemSetting {
    SettingId: number;
    Setting: string;
    SettingValue: string;
}

//CompleteAndUnresolved Reason
export class JobStatusReason {
    StatusReasons: StatusReasons[];
    TotalRecord: number;
}

export class StatusReasons {
    StatusReasonId: number;
    StatusReason: string;
    JobStatusId: number;
    JobStatus: string;
    RecordType: number;
}


/**Special Instructions and Service Notes */

export class SpecialService {
    NotesID: number;
    NotesMasterId: number;
    PrimaryKeyId: number;
    CompanyId: number;
    Note: string;
    CreatedBy?: number;
    CreatedDate: Date;
    LastChangedBy?: number;
    LastUpdate?: Date;
    UpdateBy?: number;
    UpdateDate?: Date;
    CreateAndUpdate: number;
    CreateAndUpdateDate: string;
    tempId: number;
    CreatedByName: string;
    LastChangedByName: string;
    jobval: string;
    NoteHtml: string;
}

export class SpecialServiceModel {
    DisplayName: string;
    GetWojobSplInsDetails: SpecialService[];
    GetWojobServiceNotesDetails: SpecialService[];
    GetWojobTechnicialRemark: SpecialService[];
    AdminNotesDetails: SpecialService[];
}

/**End Special Instructions and Service Notes */

/**Job Details */

export class WoJobTaskDetails {
    WoJobDetailsId: number;
    CompanyId: number;
    WoJobId: number;
    WorkTypeId: number;
    WorkTaskId: number;
    Days: string;
    Hours: string;
    Minutes: string;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    WoCategoryId: number;
    WoCategory: string;

    WorkType: string;
    WorkTask: string;
    WorkTaskNumber: string;
    CustomerPrice: any;
    TechCost: any;
    IsAutoSchedule: boolean;
    HourAndMinutes: any;
    TaskNo: number;
    JobStatus: number;
    JobStatusId: number;
    WoStatusId: number;
    VendorName: string;
    Technician: string;
    VendorTechnician: string;
    ScheduleDate: string;
    ScheduleStartDateTime: string;
    ScheduleEndDateTime: string;
    ApptPrefDate :string;
    SlotStartTime :string;
    SlotEndTime:string;
    SlotName: string;
}

export class JobDetailListTab {
    jobdetaillist: WoJobTaskDetails[];
    TotalRecord: number;
}

export class WoJobTaskDetailsAll {
    jobDetailsList: WoJobTaskDetails[];
    workTypes: AdvancedSearch[];
}

export class Hours {
    Id: number;
    Name: string;
}

export class Minutes {
    Id: number;
    Name: string;
}

export class WorkRequestModel {
    WoCategoryId: number;
    WoCategory: string;
    WorkTypeId: number;
    WorkType: string;
    WorkTaskId: number;
    WorkTask: string;
    CustomerPrice: number;
    DaysPerTask: number;
    HoursPerTask: number;
    MinutesPerTask: number;
    IsAutoSchedule: number;
    IsActive: number;
    TechCost: number;
    AddDriveTime: number;
    Description: string;
    Scheduling: string;
    Duration: string;
    Cost: string;
    WorkGroupId: number;
}

/**End Job Details */

/**Job Equipment */
export class EquipmentCFModel {
    WoEquipmentEntity: EquipmentEntity[];
    CustomFieldEntity: CustomFieldsConfiguration;

}
export class EquipmentEntity {
    BrandId: number;
    Brand: string;
    ModelId: number;
    Model: any;
    SerialNo: string;
    TagNo: string;
    Description?: string;
    WoEquipmentId: number;
    CustomerEquipmentId: number;
    ContractStartDate: string;
    ContractEndDate: string;
   // ContractType: string;
    ContractTypeId: number;
    ManufactureDate: string;
    WarrantyExpiryDate: string;
    



    IsContractExpiredColor?: string;

    CompanyId: number;
    WoJobId: number;
    WorkOrderId: number;
    WoAddressId: number;
    IsActive: number;
    //InstallationDate?: Date;
    InstallationDate?: string;
    CreatedBy?: number;
    CreatedDate?: Date;
    LastChangedBy: number;
    LastUpdate?: Date;
    CustomerId: number;

    //Add Existing
    BrandName?: string;
    WoJobNumber?: number[];
    WoJobEquipmentId?: number;
    CustAddressId?: number;

    PriorityId?: number;
    Duration?: number;
    Durationstr: string;
    PriorityColor: string
    ContractSDate?: string;
    ContractEDate?: string;

   
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    Status?: string;
    isactive?: number;
    // JobStatusId:number;
    isEdit?: boolean;
}

export class ArrEquipment {
    data: EquipmentEntity;
}

export class EquipmentEntitys {
    CompanyId: number;
    WorkOrderId: number;
    WoAddressId: number;
}

export class JobEquipmentTab {
    jobEquipmentList: EquipmentEntity[];
    TotalRecord: number;
}

/**End job Equipment */

/**Job History */

export class JobHistory {
    AuditLogId: number;
    StatusDate: string;
    Status: string;
    JobId: number;
    StatusReason: string;
    UpdatedBy: string;
    Remarks: string;
    LastModifyDate: any;
}

/**End History */

/** Update Status Model */

export class TechnicianJobStatusUpdate {
    WorkOrderId: number;
    jobid: number;
    WoAppointmentId: number;
    jobstatus: number;
    unresolvedreasonid: number;
    companyid: number;
    StartDate: string;
    StartTime: string;
    ArrivalTime: string;
    ArrivalDate: string;
    ServiceStartTime: string;
    ServiceEndTime: string;
    LastChangedBy: number;
    lastupdate: Date;
    ismobile: number;
    ServiceEndDate: string;

    CompleteResonId: number;
    UnResolveReasondId: number;
    ScheduleStartDate: string;
    LoginId: number;
    TechTimeZoneid: number;
    ActualWorkedHours: number;
    ActualWorkedMinutes: number;

    TechnicianId: number;
    PreviousJobStatus: number;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    ActualTravelDistance?: number;
    TravelCostPerKMMile?: number;
    StatusReasonId: number[];
    isGenerateOTP?: boolean;
    Days?: number;
    Hours?: number;
    Minutes?: number;
    isSingleWorkRequest?: boolean = false;
}

/** End Update Status Model */

/** Attachment */

export class AttachmentsModel {
    WoAttachmentId: number;
    CompanyId: number;
    WorkOrderId: number;
    WoJobId: number;
    AttachmentCategoryId: number;
    AttachementTypeId: number;
    Description: string;
    CapturedDate: string;
    CapturedTime?: Date;
    FileName: string;
    FilePath: string;
    CreatedBy: number;

    LastChangedBy: number;
    Attachment: string;

    AttachementType?: string;
    AttachementCategoryType?: string;
    Type: string;
    TimeZoneId?: number;
    TimeZoneDesc?: string;
    LastUpdate?: Date;
    RefCapturedDate?: string;
    DocThumbImage?: string;
    DocType: boolean;
    CapturedDateFormat?: any;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    Latitude: number;
    Longitude: number;
    Address: string;
    GPSCode?: number;
    IsEdit?: boolean;
    CreatedByName: string;
    LastChangedByName: string;
    CreatedDate: string;
    OrderId: number;
}

export class AttachmentsListModel {
    WoAttachmentId: number;
    CompanyId: number;
    WorkOrderId: number;
    WoJobId: number;
    AttachmentCategoryId: number;
    AttachementTypeId: number;
    Description: string;
    CapturedDate: string;
    CapturedTime?: Date;
    FileName: string;
    FilePath: string;
    CreatedBy: number;
    LastChangedBy: number;
    Attachment: string;
    Type: string;
    AttachementType?: string;
    AttachementCategoryType?: string;

    //formatdate
    CapturedDateFormat?: any;
    LastUpdate?: Date;
    LastUpdates?: string;
    Latitude: number;
    Longitude: number;
    Address: string;
    GPSCode?: number;
    IsEdit?: boolean;
    CreatedByName: string;
    LastChangedByName: string;
    CreatedDate: string;
    OrderId?: number;
}

export class ThumbList {
    Type: string;
    AttachmentsGroupList: AttachmentsListModel[];
}

export class AttachmentReOrderList {
    CompanyID: number;
    ModuleId: number;
    AttachmentId: number;
    Orderid: number;
}

export class Photo {
    ConfigDtlId: number;
    Description: string;
}

export class Document {
    ConfigDtlId: number;
    Description: string;
}
/** End Attachment */

/** CheckList */

export class ChecklistModel {
    WoJobChklistId: number;
    WoJobId: number;
    ChklistMastId: number;
    CompanyId: number;
    ChklistName: string;
    Description: string;
    IsActive: number;
    CreatedBy: number;
    LastChangedBy: number;
    Mandatory: number;
    Mandatorybool: boolean;
    WorkOrderId: number;
    CustomerId: number;
    AttachmentRequiredCount: number;
    AttachmentRequiredCountbool: boolean;
}
export class ChecklistDropdown {
    ChklistMastId: number;
    ChklistName: string;
    Description: string;
    IsActive: number;
}

//Dynamic Check List

export class DynamicCheckList {
    ChklistActiveDtl: number;
    CompanyId: number;
    ChklistDtlId: number;
    ChklistMastId: number;
    QuestionId: number;
    Question: string;
    FieldTypeId: number;
    IsOptional: boolean;
    MaxLength: number;
    FieldUnits: string;
    OrderNo: number;
    ChklistDdMastId: number;
    ChklistStatusId: number;
    IsActive: boolean;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    dropdownvalues: DropDownValues[];
}

export class DropDownValues {
    ChklistDdDtlId: number;
    ValueList: string;
    IsActive: number;
}

export class DynamicCheckListDtl {
    CheckListDtl: DynamicCheckList[];
}

/** End CheckList */

/**payment details */

export class PaymentModel {
    WoJobPaymentId: number;
    CompanyId: number;
    WorkOrderId: number;
    WoJobId: number;
    PaymentModeId: number;
    CashReceived: any;
    OtherAmount: any;
    ChequeNo: string;
    ChequeDate: string;
    BankName: string;
    ReceiptNo: string;
    CreatedBy: number;
    LastChangedBy: number;
    TimeZoneId?: number;
    CreatedSourceId: number;
    UpdatedSourceId: number;
}
/**end payment details */

/**pricing details */
export class PricingModel {
    WoJobPriceId: number;
    WorkTask: string;
    Description: string;
    Qty: any;
    UnitPrice: any;
    Discount: any;
    DiscountTypeId: number;
    PriceTypeId: number;
    WorkTaskNumber: string;
    WoJobDetailsId: number;
    PriceType: string;
    TaskNo: number;

    TotalAmount: any;
    NetTotal: any;
    JobTotal: any;
    WorkTypeId: number;
    WorkTaskId: number;
    WoJobId: number;
    CreatedSourceId: number;
    UpdatedSourceId: number;
    Tax: string;
    Percentage: number;
    IsEdit: boolean;
    TaxIdGroupId?: number;
    ApprovalStatusId: number;
    IsBOQRequest?: number;
    VendorId?: number;
    ApprovedQty?: number;
    PTotal: string;
    Item: string;
    PricingUnit: string;
    PricingUnitId: number;
    Warranty: number;
    DaysPerTask: number;
    HoursPerTask: number;
    MinutesPerTask: number;
    WorkGroupId: number;
    PricingCount:number;
    jobGrandTotal:number;
}
export class priceJob {
    WoJobId: number;
}
export class PricingModelListEntity {
    PricingModelTable: PricingModelTable[];
    WoJobId: number;
    NetTotalPrint: any;
}
export class PricingModelTable {
    WoJobPriceId: number;
    WorkTask: string;
    Description: string;
    Qty: any;
    UnitPrice: any;
    Discount: any;
    DiscountTypeId: number;
    PriceTypeId: number;
    WorkTaskNumber: string;
    WoJobDetailsId: number;
    PriceType: string;
    TaskNo: number;
    JobStatusId?: number;
    TotalAmount: any;
    NetTotal: any;
    JobTotal: any;
    WorkTypeId: number;
    WorkTaskId: number;
    CompanyId?: number;

    NetTotalFormat?: any;
    UnitPriceFormat?: any;
    TotalAmountFormat?: any;
    DiscountFormat?: any;
    QtyFormat?: any;
    WoJobId: number;
    netTotal?: any;
    TaxFormat?: any;
    TotalWorkOrderPrice?: number;
    CreatedBy?: number;
    CreatedSourceId: number;
    UpdatedSourceId: number;
    Tax: string;
    Percentage: number;
    IsEdit: boolean;
    TaxIdGroupId?: number;
    ApprovalStatusId: number;
    IsBOQRequest?: number;
    VendorId?: number;
    ApprovedQty?: number;
    totalrowspan?: number;
    printNetTotal?: number;
    PDiscountAmt?: any;
    PTaxAmt?: any;
    PTotal: string;
    Item: string;
    PricingUnit: string;
    PricingUnitId: number;
    Warranty: number;
    DaysPerTask: number;
    HoursPerTask: number;
    MinutesPerTask: number;
    WorkGroupId: number;
    PricingCount:number;
    jobGrandTotal:number;
}

export class PricingFormModel {
    WoJobPriceId: number;
    CompanyId: number;
    WoJobId: number;
    WoJobDetailsId: number;
    WorkTypeId: number;
    WorkTaskId: number;
    PriceTypeId: number;
    Qty: number;
    UnitPrice: any;
    Description: string;
    DiscountTypeId: number;
    Discount: any;
    TaskNo: number;
    CreatedBy: number;
    LastChangedBy: number;
    CreatedSourceId: number;
    UpdatedSourceId: number;
    Tax: string;
    TaxPercent: number;
    Warranty: number;
    PricingUnitId: number;
    DaysPerTask: number;
    HoursPerTask: number;
    MinutesPerTask: number;
    MenuId?:number;
}


export class ConfigValue {
    ConfigDtlId: number;
    description: string;
    ConfigMasterId: number;
}
/**end pricing details */

/**signature */
export class SigNature {
    WoAppointmentId: number;
    CompanyId: number;
    LastChangedBy: number;
    LastUpdate: number;
    CustomerSignature: string;
    IsCustomerSignatureReq: boolean;
    SignByName: string;
    customerfeedBack: Feedback;
}
/**end signature */

/**Recent Order History */
export class RecentOrderHistory {
    ScheduleDate: string;
    ScheduleStartDateTime: string;
    WoNumber: string;
    WoStatusId: number;
    WoStatus: string;
    JobNo: number;
    JobStatusId: number;
    JobStatus: string;
    WorkTaskId: number;
    WorkTask: string;
    WorkType: string;
    DisplayName: string;
    CreatedBy: string;
    CreatedDate: Date;
    ClosedDate: Date;
    TechName: string;
    ScheduleDateFormat: any;
    CreatedDateFormat: any;
    ClosedDateFormat: any;
    WoJobId: number;
    TaskNo: number;
    ServiceAddress: string;
    IsPmOrder: any;
    WoCategory: string;
    WorkOrderId: number;
    techid?:number;
}
/**End Recent Order History */


export class sample {
    key: number;
    value: string;
}

export class ControlsName {
    key: number;
    value: string;
}

export class DynamicCheckListDetails {
    WoJobChecklistDetailId: number;
    WoJobId: number;
    CompanyId: number;
    ChklistDtlId: number;
    ChklistMastId: number;
    QuestionId: number;
    Question: string;
    FieldTypeId: number;
    IsOptional: boolean;
    MaxLength: number;
    FieldUnits: string;
    OrderNo: number;
    ChklistDdMastId: number;
    ChklistStatusId: number;
    IsActive: boolean;
    CreatedBy: number;
    Description: string;
    ValueList: string;
    WoJobChklistId: number;
    //dropdownvalues
    dropdownvalues: DropDownValues[];
    formconName: string;
    ControlType: string;
    TextValue: string;
    BooleanValue: number;
    WoChklistDdId: number;
    ChklistActiveDtl: number;
    AllowAttachment: number;
    ParentQuestionId: number;
    ParentQuestionAnswerId: number;
    MultiCheckBoxControl: number[] = [];
    AttachmentCount: number;
    show: boolean = false;
    WorkOrderId: number;
    //Custom Field Changes
    CFDropDownId: number;
    DtValue: any;
    FieldSourceId?: number;
    FieldId?: number;
    SubFormParentId?: number;
    PrimaryEntityId?: number;
    IsReadOnly?: number;
    SubFormList: DynamicCheckListDetails[];
    SubFormParantQuestion: string = ''; // Only For UI
    IsSubFormQuestion: boolean;
    attachmentDetails: AttachmentDetails[];
}

export class SaveDynamicChecklist {
    Questions: DynamicSaveModel[];
    CommonData: CommonData;
}

export class AttachmentDetails {
    Attachment: string;
    AttachmentDescription: string;
    AttachmentType: string;
    AttachmentCaptured: string;
    AttachmentCategory: string;
    ChklistName: string;
    AttachmentCategoryId: number;
}

export class CommonData {
    CustomerId: number;
    WorkOrderId: number;
    WoJobId: number;
    CompanyId: number;
}

export class DynamicSaveModel {
    WoJobChecklistDetailId?: number;
    CompanyId?: number;
    WoJobId?: number;
    WoJobChklistId?: number;
    ChklistDtlId?: number;
    FieldTypeId?: number;
    TextValue?: string;
    BooleanValue: number;
    WoChklistDdId?: number;
    CreatedBy?: number;
    CreatedDate?: Date;
    ChklistMastId?: number;
    LastUpdate?: Date;
    LastChangedBy?: number;
    IsOptional: boolean;
    formconName: string;
    ControlType: string;
    Hidden: string;
    ChklistActiveDtl: number;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    //CheckBoxList
    MultiCheckBoxControl: number[] = [];
    //CustomField
    CFDropDownId: number;
    DtValue: string;
    FieldSourceId?: number;
    FieldId?: number;
    SubFormParentId?: number;
    PrimaryEntityId?: number;
}

export class ATextBox {
    Id: number;
    Value: string;
}
export class NTextBoxData {
    Id: number;
    Value: string;
}
export class DropDownData {
    Id: number;
    Value: string;
}
export class CheckBoxData {
    Id: number;
    Value: string;
}
export class DynamicData {
    Id: number;
    Value: any;
}

export class DynamicModel {
    Questions: DynamicCheckListDetails[] = [];
    Answers: DynamicSaveModel[] = [];
}

export class PrintPreviewModel {
    CustomerName: string;
    ContactName: string;
    ServiceOrder: number;
    JobId: number;
    Technician: string;
    TotalJobDuration: any;
    ServiceAddress: any;
    ServiceNotes: any;
    SpecialInstructions: any;
    CustomerID: number;
    Phone: string;
    CreatedDate: string;
    ScheduledDate: string;
}

/**Submit technician Job */
export class TechJobSubmit {
    CheckListId: number[];
}

export class UpdateSubmiteStatus {
    CompanyId: number;
    WoJobId: number;
    WoAppointMentId: number;
    UserId: number;
    SubmittedDate?: Date;
    SubmittedSource: number;
    VendorId: number;
    TechId: number;
    CreatedBy: number;
    WorkOrderId: number;
    IsInhouse: number;
}

export class Pricing {
    WoPriceDetailList: PricingModel[];
    TasknoList: number[];
    JobIdList: number[];
    ConfigValues: Titles[];
    WoJobDetails: WoJobTaskDetails[];
    TotalWorkOrderPrice?: number;
}

export class AddressList {
    Addressname: string;
    CustomerAddressId: number;
}

export class WoEquipmentTab {
    equipmentDetailList: EquipmentEntity[];
    jobIdList: number[];
    addressList: AddressList[];
    cusWojobEquipmentId: KeyValue[];
}

export class KeyValue {
    id: number;
    value: string;
}
export class WoEquipmentCFModel {
    WoEquipmentEntity: WoEquipmentEntity[];
    CustomFieldEntity: CustomFieldsConfiguration;

}
export class WoEquipmentEntity {
    BrandId: number;
    Brand: string;
    ModelId: number;
    Model: string;
    SerialNo: string;
    TagNo: string;
    Description?: string;
    WoEquipmentId: number;
    CustomerEquipmentId: number;
    ContractStartDate: string;
    ContractEndDate: string;
    ContractTypeId: number;
    ManufactureDate: string;
    WarrantyExpiryDate: string;
   


    CompanyId: number;
    WoJobId: string;
    WorkOrderId: number;
    WoAddressId: number;
    IsActive: number;
    InstallationDate: string;
    //InstallationDate: Date;
    CreatedBy?: number;
    CreatedDate?: Date;
    LastChangedBy?: number;
    LastUpdate?: Date;
    CustomerId: number;

    //Add Existing
    BrandName?: string;
    RemovedjobId?: RemovedEquipments[];
    WoJobEquipmentId?: number;
    CustAddressId?: number;

    PriorityId?: number;
    Duration?: number;
    Durationstr?: string;
    PriorityColor?: string;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;

}



export class WoAttachement {
    attachementDetails: AttachmentsModel[];
    jobIdList: number[];
    ContactType: Titles[];
}

export class PaymentDetails {
    WoJobPaymentId: number;
    CompanyId: number;
    WorkOrderId: number;
    WoJobId: number;
    PaymentModeId: number;
    CashReceived: any;
    OtherAmount: any;
    ChequeNo: string;
    ChequeDate: string;
    BankName: string;
    ReceiptNo: string;
    CreatedBy: number;
    LastChangedBy: number;
    PaymentMode: string;
    AmountCollected: number;
    CashReceivedFormat: string;
    OtherAmountFormat: string;
}

export class AddExistingModel {
    WoJobId: number[];
}

export class RemovedEquipments {
    WoJobId: number;
    WoEquipmentId: number;
    CompanyId: number;
}

export class Sample1 {
    WoJobId: number;
    CompanyId: number;
    CustomerEquipmentId: number;
}

export class Sample2 {
    WoJobId?: number;
    CompanyId: number;
    CustomerEquipmentId: number;
}

export class CustomerTimeZone {
    CustomerDateTime: string;
    CurrentDateTime: string;
}

export class Logo {
    fileName: string;
    filePath: string;
    attachment: string;
}

export class PrintPreview {
    CompanyId: number;
    WorkorderId: number;
    TechId: number;
    WoJobId: number;
    CustomerName: string;
    CustomerId: number;
    ContactName: string;
    Phone1: string;
    TechDisplayName: string;
    CreatedDate: Date;
    ScheduleDate: Date;
    ApptPrefDate: Date;
    Days: number;
    Hours: number;
    Minutes: number;
    AddressLine1: string;
    AddressLine2: string;
    UnitNo: string;
    CityName: string;
    ZipCode: string;
    TotalJobDuration: any;
    ServiceAddress: any;
    TimeZoneDesc: string;
    TimeZoneId: number;
    CustomerType: string;
    Email: string;
    CustomerEmail: string;
    WoNumber: string;
    ClliCode: string;
    IsNetwork?: number;
    ProjectName: string;
    CategoryName: string;
    ReferenceNo?: string;
    WoStatus: string;
    PriorityName: string;
    StateShortName: string;
    Phone2: string;
    BillingContactName: string;
    BillingCustomerEmail: string;
    BillingAddressLine1: string;
    BillingAddressLine2: string;
    BillingUnitNo: string;
    BillingCityName: string;
    BillingStateShortName: string;
    BillingZipCode: string;
    BillingAddress: string;
    BillingPhone1: string;
    BillingPhone2: string;
    CountryName: string;  
    JobStatus:string;
    VendorName:string;
    networktype:string;
    signbyname:string;
    IsCustomerSignatureReq?:number;
    ActualWorkedDays:number;
    ActualWorkedHours:number;
    ActualWorkedMinutes :number;
    ActualTravelDistance:string;
    ActualTravelTime: number;
}
//Added by Balaji 12/03/2019
export class JobPrintPre {
    CustomerTechDetail: PrintPreview;
    JobDetail: WoJobTaskDetails[];
    SpecialServicelist: SpecialService[];
    Equipment: EquipmentEntity[];
    SlaHistoryEntity: WoSLAHistory[];
    PartRequest: PartRequestList;
    specialInstruction: SpecialService[];
    serviceNotes: SpecialService[];
    PCheckList: PCheckList[];
    thumbListFilter: ThumbList[];
    JobRMAPartDetails:JobRMAPartDetails[];
    attachmentsqueue: attachmentchecklist[];
    pricingModelTable:PricingModelTable[];
    technicalRemarks: SpecialService[];
    travelConveyance: TravelConveyance[];
}
export class JobRMAPartDetails{
    WoJobId:number;
    PartRequestId:number;
    ShipVia:string;
    ShippingDate:Date;
    TrackingNo:string;
    ETADate:Date;
    RMATrackingNo:string;
    ETATime:string;
    RMANo:string;
    RMAShippingDate:Date;
}
export class JobPrintPreWhole {
    CustomerTechDetail: CustomerDetails
    JobDetail: JobDetails;
    //SpecialServicelist: SpecialService[];
    Equipment: EquipmentDetails;
    SlaHistoryEntity: WoSLAHistoryDetails;
    PartRequest: PartRequestDetails;
    specialInstruction: specialInstructionDetails;
    serviceNotes: serviceNotesDetails;
    PCheckList: PCheckListDetails;
    thumbListFilter: thumbListFilter;
    JobRMAPart:JobRMAPartDetailsEntity;
    JobShipping:JobShippingDetailsEntity;
    attachmentsqueue:PCheckListAttachmentDetails;
    pricingModelTable:PricingDetailsEntity;
    technicalRemarks: technicianRemarksDetails;
    travelConveyance:TravelConveyanceEntity;
}

export class TravelConveyance{
    AWorkduration:string;
    ATravelDistance:string; 
    ATravelDuration: string;
}

export class TravelConveyanceEntity{
    SortId:number;
    SettingId:number; 
    TravelConveyance: TravelConveyance[];
}
export class JobRMAPartDetailsEntity{
    SortId:number;
    SettingId:number; 
    JobRMAPart: JobRMAPartDetails[];
}
export class JobShippingDetailsEntity{
    SortId:number;
    SettingId:number; 
    JobShipping: JobRMAPartDetails[];
}
export class PricingDetailsEntity{
    SortId:number;
    SettingId:number; 
    pricingModelTable: PricingModelTable[];
}

export class attachmentsqueueEntity{
    SortId:number;
    SettingId:number; 
    attachmentsqueue: attachmentchecklist[];
}
export class JobPrintPreWholedup {
    JobPrintDetails:any[]=[];
}
export class WoSLAHistoryDetails{
    SortId:number;
    SettingId:number;
    SlaHistoryEntity:WoSLAHistory[]
}
export class CustomerDetails{
    SortId:number=0;
    SettingId:number=0;
    CustomerTechDetail: PrintPreview;
}
export class JobDetails{
    SortId:number=0;
    SettingId:number=0;
    JobDetail: WoJobTaskDetails[];
}
export class EquipmentDetails{
    SortId:number;
    SettingId:number;
    Equipment: EquipmentEntity[];
}

export class PartRequestDetails{
    SortId:number;
    SettingId:number;
    PartRequest: PartRequestList;
}
export class specialInstructionDetails{
    SortId:number;
    SettingId:number;
    specialInstruction: SpecialService[];
}
export class serviceNotesDetails{
    SortId:number;
    SettingId:number;
    serviceNotes: SpecialService[];
}
export class technicianRemarksDetails{
    SortId:number;
    SettingId:number;
    technicalRemarks: SpecialService[];
}
export class PCheckListDetails{
    SortId:number;
    SettingId:number;
    PCheckList: PCheckList[];
}
export class PCheckListAttachmentDetails{
    SortId:number;
    SettingId:number;
    PCheckListAttachment: PCheckList[];
}

export class thumbListFilter{
    SortId:number;
    SettingId:number;
    thumbListFilter: ThumbList[];
}
export class PrintEquipmentEntity {
    WoJobId: number;
    SettingId:number;
    EquipmentEntitylist: EquipmentEntity[];
}


export class PrintJobDetails {
    WoJobId: number;
    JobDetail: WoJobTaskDetails[];
    VendorTechnician: string;
}

export class PrintPartRequest {
    WoJobId: number;
    PartRequest: PartRequestEntity[];
}
export class PartRequestList {
    TotalRecord: number;
    PartLists: PartRequestEntity[];
}
//Added by Balaji
export class PartRequestEntity {
    WoJobId: number;
    PartNo: string;
    PartRequestNo: string;
    Description: string;
    PartReqStatus: string;
    RequestedQty: number;
    PartId: number;
    PartReqStatusId: number;
    PartRequestId: number;
    Status: boolean;

    AttachmentExists: number;
}
//Added by Balaji
export class PartRequestListEntity {
    PartLists: PartRequestEntity[];
    TotalRecord: number;
}
export class WoSLAHistory {
    WoJobId: number;
    SLAStartTime: string;
    SLAEndTime: string
    IsSLAMet: number;
    CreatedDate: string
    ApptPrefDate: string;
    Duration: number;
    Durationstr: string;
    PriorityName: string;
    PriorityId: number;
    Color: string;
    JobStatusId: number;
    ActualSLAEndTime: string;
    SLAType: string;
    SLATypeId: number;
    ShowSlaTimer: number;
    SLAApplied: number;
    ResolutionSLADurationType: string;
    ResponseSLADurationType: string;
    RespSLADurationTypeId: number;
    ReslSLADurationTypeId: number;
    isEdit: boolean;
    slacount:number;
}
export class PrintPreviewList {
    PrintPreviewmodel: PrintPreview;
    JobDetaillist: WoJobTaskDetails[];
    Equipmentlist: EquipmentEntity[];

}

export class ClosePopup {
    Responce: boolean;
    AdditionalInfo?: any;
}
export class companyvendor {
    VendorId?:number
    VendorName:string;
}
export class RouteParams {
    WoJobId: number;
    WorkOrderId: number;
    ServiceAddressId: number;
    BillingAddressId: number;
    WoCategoryId: number;
    CustomerId: number;
    TimeZoneId: number;
    TechnicianName: string;
    WoNumber: string;
    TimeZoneDesc: string;
    VendorName: string;
    CustAddressId: number;
    TechnicianId: number;
}
//Notes
export class NotesModel {
    NotesID: number;
    NotesMasterId: number;
    PrimaryKeyId: number;
    CompanyId: number;
    Note: string;
    CreatedBy?: number;
    CreatedDate: Date;
    LastChangedBy?: number;
    LastUpdate?: Date;
    UpdateBy?: number;
    UpdateDate?: Date;
    CreateAndUpdate: number;
    CreateAndUpdateDate: string;
    tempId: number;
    Jobno: number;
    jobval: string;
    CreatedSourceId: number;
    UpdatedSourceId: number;
}

//Job Details
export class JobDetailsList {
    WoJobDetailsId: number;
    CompanyId: number;
    WoJobId: number;
    WorkTypeId: number;
    WorkTaskId: number;
    Days?: number;
    Hours?: number;
    Minutes?: number;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    WoCategoryId: number;
    WoCategory: string;
    WorkType: string;
    WorkTask: string;
    WorkTaskNumber: string;
    CustomerPrice: any;
    TechCost: any;
    IsAutoSchedule: boolean;
    HourAndMinutes: any;
    TaskNo: number;
    WorkGroupId: number
}

export class WorkTypeDd {
    WorkTypeId: number;
    WoCategoryId: number;
    WorkType: string;
    PriorityId: number;
}

export class WOCategory {
    WoCategoryId: number;
    CompanyId: number;
    WoCategory: string;
    Description: string;
    IsDefault: number;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy?: number;
    LastUpdate: string;
}

export class WorkRequestDd {
    WoCategoryId: number;
    WoCategory: string;
    WorkTypeId: number;
    WorkType: string;
    WorkTaskId: number;
    WorkTask: string;
    CustomerPrice: number;
    DaysPerTask: number;
    HoursPerTask: number;
    MinutesPerTask: number;
    IsAutoSchedule: number; s
    IsActive: number;
    TechCost: number;
    AddDriveTime: number;
    WorkGroupId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    PricingUnitId: number
}
export class WorkRequestCFModel {
    WorkRequestSaveModel: WorkRequestSaveModel;
    CustomFieldEntity: CustomFieldsConfiguration;

}
export class WorkRequestSaveModel {
    WoJobDetailsId: number;
    CompanyId: number;
    WoJobId: number;
    WorkTypeId: number;
    WorkTaskId: number;
    Days?: number;
    Hours?: number;
    Minutes?: number;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    WoCategoryId: number;
    WoCategory: string;
    WorkType: string;
    WorkTask: string;
    WorkTaskNumber: string;
    CustomerPrice: any;
    TechCost: any;
    IsAutoSchedule: boolean;
    HourAndMinutes: any;
    TaskNo: number;
    WorkGroupId: number;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    WorkOrderId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    WorkTypePriorityId: number;
    CustomerId: number;
    Qty: number;
    PricingUnitId: number;
    VendorId?:number;
    menuid?:number;
    TechId?:number;
}

//Equipment
export class EquipmentListModel {
    BrandId: number;
    Brand: string;
    ModelId: number;
    Model: string;
    SerialNo: string;
    TagNo: string;
    Description?: string;
    WoEquipmentId: number;
    CustomerEquipmentId: number;
    WoJobEquipmentId: number;
    CompanyId: number;
    WoJobId: number;
    WorkOrderId: number;
    WoAddressId: number;
    ContractStartDate: string;
    ContractEndDate: string;

    ContractTypeId: number;
    ManufactureDate: string;
    WarrantyExpiryDate: string;
    InstallationDate: string;

    ContractSDate: string;
    ContractEDate: string;

    ManufactDate: string;
    WarrantyDate: string;
    InstallDate: string;


    IsContractExpiredColor: string;
    PriorityId?: number;
    Duration?: number;
    Durationstr: any;
}


export class ExistingEquipmentModel {
    BrandId: number;
    BrandName: string;
    ModelId: number;
    Model: number;
    SerialNo: string;
    TagNo: string;
    Description: string;
    CustomerEquipmentId: number;
    AddressName: string;
    IsActive: number;
    CustomerId: number;
    ContractStartDate: string;
    ContractEndDate: string;
    IsContractExpiredColor: string;
    PriorityId?: number;
}

export class BrandList {
    BrandId: number;
    Brand: string;

}
export class ModelList {
    ModelId: number;
    Model: string;

}
export class Projects {
    ProjectId: number;
    ProjectName: string;
}
export class TimezoneEntity {
    TimeZoneId: number;
    TimeZoneDesc: string;
    TimeZoneCode: string;
}



export class ContactCFModel {
    CustomerContactUI: CustomerContact;
    CustomFieldEntity: CustomFieldsConfiguration;

}

export class CustomerContact {
    CustomerContactId: number;
    CompanyId: number;
    CustomerId: number;
    CustomerAddressId: number;
    AddressTypeId: number;
    Phone1: string;
    Phone2: string;
    Email: string;
    IsPrimary: any;
    TitleId: number;
    FirstName: string;
    MiddleInitial: string;
    LastName: string;
    ContactTypeId: number;
    Fax: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    ContactType: string;
    TitleName: string;
    ChangePrimary: any;

}

//TAX -- Added by Anvardeen Batcha
export class TaxGroup {
    TaxId: number;
    TaxName: string;
    TaxPercent: number;
    TaxValue: string;
    IsActive: number;
}
export class JobSlaDetails {
    WoJobId: number;
    PriorityName: string;
    ShowSlaTimer: number;
    IsSlaEnabled: number;
    SLAStartTime: string;
    SLAEndTime: string;
    ActualSLAEndTime: string;
    Duration: number;
    IsSLAMet: number;
    SLATypeId: number;
}
export class PrintNotesModel {
    NotesType: string;
    UpdatedBy: string;
    UpdatedOn: string;
    Notes: string;
}

export class PrintcheckListModel {
    ChklistMastId: number;
    CompanyId: number;
    WoJobChklistId: number;
    WoJobId: number;
    ChklistName: string;
    Description: string;
    LoginId: number;
}

export class PrintCheckListOutput {
    CustomerInfo: PrintCheckListHeader;
    PCheckList: PCheckList[];
}

export class PCheckList {
    WoJobChklistId: number;
    ChklistName: string;
    Description: string;
    WoJobEquipmentId: number;
    QuestionAnswer: DynamicCheckListDetails[];
    attachementsFilter: attachmentchecklist[];

}

export class PrintCheckListHeader {
    ChklistLogoPath: string;
    ChkListHeaderPath: string;
    ChkListFooterPath: string;
    CustomerName: string;
    Phone: string;
    ServiceAddress: string;
    WoNumber: string;
    WoJobId: string;
    WoCategory: string;
    DisplayName: string;
    ScheduleStartDateCtz: string;
    ServiceEndTimeCtz: string;
    ContactName: string;
    ContactPhone: string;
    CustomerType?:string;
}

export class printCheckListQuestionAnswer {
    WoJobChklistId: number;
    Question: string;
    TextValue: string;
    BooleanValue: string;
    Description: string;
    ValueList: string;
    WoJobEquipmentId: number;
    FieldUnits: string;
}
export class Company {
    CompanyId: number;
    CompanyName: string;
    ShortName: string;
    Phone: string;
    Fax: string;
    Email: string;
    Website: string;
    UnitNo: string;
    CityName: string;
    StateId: number;
    ZipCode: string;
    CountryId: number;
    StateName: string;
    CountryName: string;
    Status: any;
    IsActive: number;
    PrimaryContactName: string;
    AddressLine1: string;
    AddressLine2: string;
    StateShortName: string;
    Address: string;

    LicenseValidUpto: string;
    LicenseAlertBefore: number;
    DefaultLocaleId: number;
    DefaultLanguageId: number;
    DefaultCurrencyId: number;
    DefaultCountryId: number;
    DefaultThemeId: number;
    Edition: any;
    EditionId: number;
    EnableOptimization: number;
    EnableMultiVendor: number; //Added by Anvardeen Batcha
    IsProjectEnabled: number; //Added by Anvardeen Batcha
    EnableMultiVendorShrTech: number; //Added by Anvardeen Batcha
    EnableJobVendorSwitch: number; //Added by Anvardeen Batcha
    IsTaxEnabled: number; //Added by Anvardeen Batcha
    MaxUsers: number;
    MaxWoLicense: number;

    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    VendorId: number;

    LogoPath: string;
    ChklistLogoPath: string;
    ChkListHeaderPath: string;
    ChkListFooterPath: string;
    PrintoutLogoPath: string;
    PrintoutHeaderPath: string;
    PrintOutFooterPath: string;
    WeekEnd: any; // region As discussed with vijay TN  company based weekend implemented  // Added/ Modified by Anvardeen Batcha B

    DefaultLanguageIds: number[];
    IsLatLonBased: number;
    DefaultCountryIds: number[];
}

export class DownloadFile {
    fileName: string;
}

export class EmailJobAttachement {
    CompanyId: string;
    WoJobId: string;
    LoginId: string;
    AttachementContent: string;
    IsInvoice: number;
    InvoiceId: string;
}

export class SendEmailJob {
    CustomerName: string;
    To: string;
    Subject: string;
    Attachement: string;
    Body: string;
    LoginId: string;
    CompanyId: string;
    WoJobId: string;
    WorkOrderId: number;
    AttachementContent: string;
    IsInvoice: number;
    InvoiceId: string;
    SourceId?: number;
    
    
}
export class PartPricing {
    TaskNo: number;
    PartRequestId: number;
    description: string;
    qty: any;
    unitPrice: any;
    NetTotal: any;
    JobTotal: any;
    discount: any;
    discounttype: number;
    total: any;
    priceTypeId: number;
    priceIndx: number;
    wopartpriceid: number;
    DiscountTypeId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    Percentage: number;
    Tax: string;
    TaxFormat?: any;
    NetTotalFormat?: any;
    WoJobId: number;
    CompanyId: number;
    CreatedBy: number;
    LastChangedBy: number;
    CreatedSourceId: number;
    UpdatedSourceId: number;
}
export class jobNumber {
    wojobid: number;
}

export class SystemSettings {
    SettingId: number;
    settingValue: string;
}

export class SaveOTP {
    CompanyId: number;
    WoAppointmentOTPId: number;
    WoAppointmentId: number;
    Name: string;
    Relationship: string;
    MobileNumber: string;
    OTP: string;
    OTPNotRequired: number;
    OTPReasonId: number;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
}

export class Reason {
    OTPReasonId: number;
    OTPReason: string;
}

export class OTPDetails {
    WoAppointmentOTPId: number;
    Name: string;
    Relationship: string;
    MobileNumber: string;
    OTP: string;
    OTPNotRequired: number;
    OTPReasonId: number;
    OTPReason: string;

}
export class Feedback {
    CustomerFeedbackId: number;
    CompanyId: number;
    WoJobId: number;
    WorkOrderId: number;
    VendorId: number;
    CustomerId: number;
    TechId: number;
    Rating: number;
    Feedback: string;
    FeedbackBy: string;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
}

export class RefStatusReasonReject {
    StatusReasonId: number;
    StatusReason: string;

}

export class AcceptReject {
    CompanyId: number;
    WoJobId: number;
    AcceptanceStatusId: number;
    AcceptanceUserId: number;
    AcceptanceDate: string;
    AcceptanceSourceId: number;
    AcceptanceReasonId?: number;
    woId: number;
    woAppointMentId: number;
}

export class ChecklistAttachment {
    WoJobChklistDtlListId: number;
    CompanyId: number;
    WoJobChklistDtlId: number;
    AttachmentCategoryId: number;
    AttachementTypeId: number;
    Description: string;
    CapturedDate: string;
    FileName: string;
    FilePath: string;
    CreatedSourceId: number;
    UpdatedSourceId: number;
    CreatedSourceLoginId: number;
    UpdatedSourceLoginId: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    WorkOrderId: number;
    WoJobId: number;
    ChklistDtlId: number;
    ChklistMastId: number;
    QuestionId: number;
    Question: string;
    Attachment: string;

}

export class attachmentchecklist {
    WoJobChklistDtlListId: number;
    CompanyId: number;
    WoJobChklistDtlId: number;
    AttachmentCategoryId: number;
    AttachementTypeId: number;
    Description: string;
    CapturedDate: string;
    CapturedTime: string;
    FileName: string;
    FilePath: string;
    CreatedSourceId: number;
    UpdatedSourceId: number;
    CreatedSourceLoginId: number;
    UpdatedSourceLoginId: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    WorkOrderId: number;
    WoJobId: number;
    ChklistDtlId: number;
    ChklistMastId: number;
    QuestionId: number;
    Question: string;
    Attachment: string;
    Category: string;
    Type: string;
    Message: string;
    DocThumbImage?: string;
    ChklistName: string;
    ImageTypes: string;

}


export class OutputValue {
    QuestionId: number;
    Count: number;
    success: boolean;
}

export class WOWorkType {
    WorkTypeId: number;
    WorkType: string;
    description: string;
    PriorityId: number;
    BusinessTypeId: number;
}
export class EmailLogDetails {
    Subject: string;
    EmailContent: string;
    ToEmail: string;
    WorkOrderid: number;
    WoJobId: number;
}
export class ChecklistGPSLocation {
    Latitude: number;
    Longitude: number;
    Checklist: string;
    Id: number;
    Image: string;
    // Reason:string;
}
export class WoJobStatusReasonEntity {
    StatusReasonId: number;
    WoJobId: number;
    WoJobStatusId: number;
    StatusReason: string;
    JobStatus: string;
    Remarks: string;
}

export class SaveCompleteStatusReason {
    CompanyId: number;
    WoJobId: number;
    StatusReason: number[];
    CreatedBy: number;
    Remarks: string;
    CreatedSourceId: number;
    ActualTravelDistance?: number;
    Days?: number;
    Hours?: number;
    Minutes?: number;
    isSingleWorkRequest?: boolean = false;
    WoAppointmentId?: number;
    inprogressid?: number;
    onhold?: number;
    Editcompletedid?: number;
}
export class EmailPrintPreview {
    CompanyId: number;
    QuoteOrderId: number;
    QuoteNumber: string;
    TechId: number;
    WoJobId: number;
    CustomerName: string;
    CustomerId: number;
    ContactName: string;
    Phone1: string;
    TechDisplayName: string;
    CreatedDate: Date;
    ScheduleDate: Date;
    Days: number;
    Hours: number;
    Minutes: number;
    AddressLine1: string;
    AddressLine2: string;
    UnitNo: string;
    CityName: string;
    ZipCode: string;
    TotalJobDuration: any;
    ServiceAddress: any;
    TimeZoneDesc: string;
    TimeZoneId: number;
    CustomerType: string;
    Email: string;
    CustomerEmail: string;
    WoNumber: string;
    ClliCode: string;
    IsNetwork?: number;
    ProjectName: string;

}
export class WoPunchPointsAttachment {
    WoPunchPointsAttachmentId: number;
    CompanyId: number;
    WorkOrderId: number;
    WOPunchPointsId: number;
    AttachmentCategoryId: number;
    AttachementTypeId: number;
    Description: string;
    CreatedBy: number;
    CreatedDate: number;
    LastChangedBy: number;
    LastUpdate: number;
    ByteString: string;
    FileName: string;
    FilePath: string;
    AttachementType: string;
    Type: string;
    DocThumbImage: string;
    DocType: boolean;
}
export class WOPunchPoints {
    WOPunchPointsId: number;
    CompanyId: number;
    WorkOrderId: number;
    SourceJobId: number;
    WoCategoryId: number;
    WorkTypeId: number;
    WorkTaskId: number;
    PunchPointStatusId: number;
    StatusDate: string;
    Remarks: string;
    Comments: string;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
}
export class ScheduleToMe {
    JobDuration: number;
    companyid: number;
    WOjobId: number;
    TechId: number;
    loginid: number;
    PreferDate: string;
    worktaskid: number;
}
export class AupWoAppointment {
    piWoJobId: number;
    piTechId: number;
    piWorkDate: string;
    piStartTime: string;
    piEndTime: string;
    piTravelTime: number;
    piDistance: number;
    piComments: string;
    piIsConfirm: number;
    piCompanyId: number;
    piLoginId: number;
    piNextJobStartTime: string;
    piNextJobId: number;
    piNextJobTravelTime: number;
    piNextJobDistance: number;
    piVendorId: number;
    scheduled: number;
    piArrivalTime: string;
    PiSourceId: number;
    workStartDate: string;
    workEndDate: string;
}
export class JobPricing {
    taskIndex: number;
    WorkTaskId: number;
    WorkTypeId: number;
    Description: string;
    Qty: any;
    UnitPrice: any;
    NetTotal: any;
    JobTotal: any;
    Discount: any;
    DiscountTypeId: number;
    total: any;
    PriceTypeId: number;
    priceIndx: number;
    WoJobPriceId: number;
    TaskNo: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    CompanyId: number;
    WoJobId: number;
    WoJobDetailsId: number;
    CreatedBy: number;
    CreatedSourceId: number;
    PricingUnitId: number;
}
export class AddEditWoJobEntity {
    WoJobId: number;
    CompanyId: number;
    WorkOrderId: number;
    ApptPrefDate: string;
    ApptPrefSlotId: number;
    ApptPrefTime: string;
    LastChangedBy: number;
    LastUpdate: string;
    WoJobDetailsId: number;
    WorkTypeId: number;
    WorkTaskId: number;
    Days: number;
    Hours: number;
    Minutes: number;
    TaskNo: number;
    CreatedBy: number;
    CreatedDate: string;
    CustomerPrice: number;
    VendorId: number;
    WorkGroupId: number;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    CustomerTypePriorityId: number;
    WorkTypePriorityId: number;
    IsCustPrefDateChanged?: number;
    CustomerId: number;
    jobPricing: JobPricing[];
    AppDetails: AupWoAppointment;
    WOPunchPointsId: number;
}
export class userRoleDetail {
    RoleId: number;
    RoleMasterId: number;
    RoleName: string;
}

export class AssignToTech {
    CompanyId: number;
    WorkOrderId: number;
    WoJobId: number;
    TechId: number;
    JobStatusId: number;
    AppointmentStatusId: number;
    WorkGroupId: number;
    LoginId: number;
    JobDayDuration: number;
    JobHourDuration: number;
    JobMinuteDuration: number;
    VendorId: number;
    LastAppointmentId: number;
    LastTechId: number;
}
export class PunchPointsList {
    WOPunchPointsId: number;
    CompanyId: number;
    WorkOrderId: number;
    SourceJobId: number;
    WoCategoryId: number;
    WorkTypeId: number;
    WorkTaskId: number;
    PunchPointStatusId: number;
    StatusDate: Date;
    Remarks: string;
    Comments: string;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    WoCategory: string;
    WorkType: string;
    WorkTask: string;
    Status: string;
    Attachmentcounts: number;
    DaysPerTask: number;
    HoursPerTask: number;
    MinutesPerTask: number;
    WorkGroupId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    CustomerPrice: number;
    PricingUnitId: number;
}

export class OTPProjectSettings {
    ProjectId: number;
    JobCompletionOTPRequired: number;
    OTPTypeId: number;
}
export class WorkDoneTimings {
    Sno: number;
    StartDateTime: string;
    EndDateTime: string;
    WorkedHr: string;
    WorkedHrs: number;
    StartJobStatus: string;
    EndJobStatus: string;
}
export class worldonetiming {
    WoJobWorkDoneTimingId?: number;
    CompanyId?: number;
    WoJobId?: number;
    TechId?: number;
    FromStatusId?: number;
    ToStatusId?: number;
    StartDate?: string;
    EndDate?: string;
    StartDateTtz?: string;
    EndDateTtz?: string;
}

export class RefEmailPrintJobSetting{
    SettingId:number;
    CompanyId:number;
    SettingName:string;
    Caption:string;
    SettingTypeId:number;
    IsEnabled:number;
    CreatedBy:string;
    OrderId:number;
    CreatedDate:string;
LastChangedBy:string;
LastUpdate:string;
}
